import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Clock } from 'lucide-react';
export function ExpectedResults() {
  return <section className="py-16 md:py-24 bg-[#0a0a0a] relative overflow-hidden" data-id="element-21">
      <div className="absolute left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-cyan-900 to-transparent hidden md:block" data-id="element-22" />

      <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-23">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12 md:mb-20" data-id="element-24">
          <h2 className="text-2xl md:text-5xl font-black text-white mb-4" data-id="element-25">
            Resultados Que Puedes <span className="text-cyan-400" data-id="element-26">Esperar</span>
          </h2>
        </motion.div>

        <div className="space-y-6 md:space-y-12" data-id="element-27">
          {/* Phase 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="relative bg-[#111] p-5 md:p-8 rounded-xl border border-white/5 md:ml-auto md:w-[calc(50%-2rem)]" data-id="element-28">
            <div className="absolute top-8 -left-12 w-6 h-6 bg-cyan-500 rounded-full border-4 border-[#0a0a0a] z-20 hidden md:block" data-id="element-29" />

            <div className="flex items-center gap-3 mb-4 md:mb-6" data-id="element-30">
              <Clock className="text-cyan-400 shrink-0" size={20} data-id="element-31" />
              <h3 className="text-lg md:text-2xl font-bold text-white" data-id="element-32">
                En los primeros 3–7 días
              </h3>
            </div>

            <ul className="space-y-2 md:space-y-3 text-sm md:text-base text-gray-300" data-id="element-33">
              <li className="flex gap-2" data-id="element-34">
                <span className="text-cyan-500" data-id="element-35">•</span>
                Notarás más energía al despertar (menos sensación de "pesadez").
              </li>
              <li className="flex gap-2" data-id="element-36">
                <span className="text-cyan-500" data-id="element-37">•</span>
                La niebla mental empezará a despejarse.
              </li>
              <li className="flex gap-2" data-id="element-38">
                <span className="text-cyan-500" data-id="element-39">•</span>
                Tu sueño será más continuo (menos despertares).
              </li>
              <li className="flex gap-2" data-id="element-40">
                <span className="text-cyan-500" data-id="element-41">•</span>
                Notarás menos picos y bajones bruscos de energía en la tarde.
              </li>
            </ul>
          </motion.div>

          {/* Phase 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="relative bg-[#111] p-5 md:p-8 rounded-xl border border-white/5 md:mr-auto md:w-[calc(50%-2rem)]" data-id="element-42">
            <div className="absolute top-8 -right-12 w-6 h-6 bg-cyan-500 rounded-full border-4 border-[#0a0a0a] z-20 hidden md:block" data-id="element-43" />

            <div className="flex items-center gap-3 mb-4 md:mb-6" data-id="element-44">
              <TrendingUp className="text-cyan-400 shrink-0" size={20} data-id="element-45" />
              <h3 className="text-lg md:text-2xl font-bold text-white" data-id="element-46">
                En 2–4 semanas
              </h3>
            </div>

            <ul className="space-y-2 md:space-y-3 text-sm md:text-base text-gray-300" data-id="element-47">
              <li className="flex gap-2" data-id="element-48">
                <span className="text-cyan-500" data-id="element-49">•</span>
                Mejor recuperación después de entrenamientos o días intensos.
              </li>
              <li className="flex gap-2" data-id="element-50">
                <span className="text-cyan-500" data-id="element-51">•</span>
                Energía más estable durante todo el día.
              </li>
              <li className="flex gap-2" data-id="element-52">
                <span className="text-cyan-500" data-id="element-53">•</span>
                Un sueño más profundo y reparador.
              </li>
              <li className="flex gap-2" data-id="element-54">
                <span className="text-cyan-500" data-id="element-55">•</span>
                Mayor claridad mental y mejor estado de ánimo.
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}